import { combineReducers, createReducer, on } from '@ngrx/store';
import { addAllAssets, decrementCurrentWizardStep, incrementCurrentWizardStep, resetCurrentWizardStep, resetSelectAllAssets, resetSelectedAssets, selectAssets, selectClient, selectPlan, setPortfolioImportType, toggleSelectAllAssets, } from './actions';
import { CLIENT_PORTFOLIO } from 'ModelPortfolioApp/ts/shared/constants';
export const currentWizardStepIndex = createReducer(0, on(incrementCurrentWizardStep, (state) => {
    return state + 1;
}), on(decrementCurrentWizardStep, (state) => {
    return state - 1;
}), on(resetCurrentWizardStep, () => {
    return 0;
}));
export const portfolioImportType = createReducer(CLIENT_PORTFOLIO, on(setPortfolioImportType, (state, { newPortfolioImportType }) => {
    return newPortfolioImportType;
}));
export const selectedClient = createReducer(null, on(selectClient, (state, { selectedClient: newClient }) => {
    return newClient;
}));
export const selectedPlan = createReducer(null, on(selectPlan, (state, { selectedPlan: newPlan }) => {
    return newPlan;
}));
export const selectAllAssets = createReducer(false, on(toggleSelectAllAssets, (state) => {
    return !state;
}), on(resetSelectAllAssets, () => {
    return false;
}));
export const currentlySelectedAssets = createReducer([], on(selectAssets, (state, { selectedAssets }) => {
    return selectedAssets;
}), on(resetSelectedAssets, () => {
    return [];
}), on(addAllAssets, (state, { assets }) => {
    return assets.map((asset) => ({
        ...asset,
        importAsSingleHolding: false,
    }));
}));
export const selectedAssetIds = createReducer([], on(selectAssets, (state, { selectedAssets }) => {
    return selectedAssets.map((asset) => asset.id);
}), on(resetSelectedAssets, () => {
    return [];
}), on(addAllAssets, (state, { assets }) => {
    return assets.map((asset) => asset.id);
}));
export const emoneyImportHoldings = combineReducers({
    currentWizardStepIndex,
    portfolioImportType,
    selectedClient,
    selectedPlan,
    selectAllAssets,
    currentlySelectedAssets,
    selectedAssetIds,
});
